"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import { AlertTriangle, ShieldAlert, Users } from "lucide-react";
export default function AdultWarnings() {
  const chipStyles = {
    // height: '32px',

    fontWeight: 500,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    variant: "outlined",
    p: 0,
    borderRadius: 1,
    "& .MuiChip-iconSmall": {
      fontSize: "1rem"
    },
    "& .MuiChip-iconMedium": {
      fontSize: "1.2rem"
    },
    "& .MuiChip-iconLarge": {
      fontSize: "1.4rem"
    },
    "& .MuiChip-icon": {
      color: "inherit",
      // marginLeft: '12px',
      //   marginRight: '-4px',
      marginTop: "-4px"
    },
    "& .MuiChip-label": {
      // padding: '0 16px',
      display: "flex",
      alignItems: "center"
      // gap: '8px',
    }
  };
  return <Box sx={{
    borderTop: "1px solid",
    borderBottom: "1px solid",
    borderColor: "divider",
    pt: 2,
    pb: 2,
    my: 0,
    bgcolor: "background.paper"
  }}>
      <Grid container spacing={2} maxWidth={"lg"} sx={{
      placeSelf: "center",
      "& .MuiGrid-item": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }
    }}>
        {/* RTA Label */}
        <Grid item xs={12} md={4}>
          <Chip icon={<ShieldAlert size={18} />} label="RTA" size="small" sx={{
          ...chipStyles,
          borderRadius: 1,
          mb: 0.3
        }} />
          <Typography variant="caption" sx={{
          // color: "text.secondary",
          opacity: 0.8,
          textAlign: "center"
        }}>
            Restricted to Adults | Este site contém conteúdo adulto
          </Typography>
        </Grid>

        {/* Anti-Child Pornography Warning */}
        <Grid item xs={12} md={4}>
          <Chip icon={<AlertTriangle size={18} />} label="Contra Pornografia Infantil" size="small" sx={{
          ...chipStyles,
          mb: 0.3
        }} />
          <Typography variant="caption" sx={{
          // color: "text.secondary",
          opacity: 0.8,
          textAlign: "center"
        }}>
            Este site proíbe estritamente pornografia infantil.{" "}
          </Typography>
        </Grid>

        {/* Age Verification */}
        <Grid item xs={12} md={4}>
          <Chip icon={<Users size={18} />} label="18+" size="small" sx={{
          ...chipStyles,
          mb: 0.3
        }} />
          <Typography variant="caption" sx={{
          // color: "text.secondary",
          opacity: 0.8,
          textAlign: "center"
        }}>
            Ao acessar este site, você confirma ter 18 anos ou mais
          </Typography>
        </Grid>
      </Grid>
    </Box>;
}